import { jsonApi } from '@models/jsonApi';

jsonApi.define('start-option', {
  default_site_id: 0,
  default_site_group_id: 0,
  default_language_id: '',
  currency: '',
  csv_separator: '',
});
